module.exports = "https://la-static.vkplay.ru/promo/newstart/img/location-4.2a1ac1e9.jpg";